'use strict';

angular.module('systemOwnerReviewControllers.DecommissionSystems')

    .controller('DecommissionSystemsBySystemTypeController', ['$scope', '$modal', '$state', '$stateParams', 'decommissionSystemsService', 'nextProcessStep', 'systemType', 'systemsToReview', function ($scope, $modal, $state, $stateParams, decommissionSystemsService, nextProcessStep, systemType, systemsToReview) {

        $scope.systemType = systemType;
        $scope.isProcessing = false;

        // Compute groups by system owners list
        var partitionSystemsToReview = _.partition(systemsToReview, {
            SystemTypeID: systemType.SystemTypeID
        });

        var systemsToReviewForType = partitionSystemsToReview[0];
        var systemsToReviewNotInType = partitionSystemsToReview[1];

        $scope.systemsToReviewForType = systemsToReviewForType;

        var groups = _.groupBy($scope.systemsToReviewForType, function (system) {
            return _.chain(system.SystemOwners)
                .map('EmployeeID')
                .sortBy()
                .value();
        });

        $scope.withSystems = Object.keys(groups).length > 0;

        // Read only ?
        $scope.isReadOnly = !nextProcessStep.IsDecommissionSystems;

        // Confirm review
        var systemNotInType =
                _.chain(systemsToReviewNotInType)
                 .filter({IsReviewed: false})
                 .first()
                 .value();

        $scope.needCloseStepReview = function () {

            var needCloseStepReview =
                    (_.findIndex(systemsToReviewForType, { IsReviewed: false }) === -1) &&
                    (_.findIndex(systemsToReviewNotInType, {IsReviewed: false}) === -1);

            return needCloseStepReview;
        }

        $scope.continueReview = function (systemsGroup) {

            var currentIndex = _.findIndex(systemsToReview, { SystemTypeID: systemType.SystemTypeID });

           //  Check if system is not the last one
            if (systemNotInType) {
                completeReview(systemsToReviewForType);
                return;
            }

            // Get all the systems
            decommissionSystemsService
                .getSystemsToToggleSetForDecommission($scope.authLogin)
                .then(function (systemsToReview) {

                    // Filter only those set to decomission
                    var systemsSetForDecommission = _.filter(systemsToReview, {
                        IsSetForDecommission: true
                    });

                    if (systemsSetForDecommission.length === 0) {
                        completeReview(systemsToReviewForType);
                        return;
                    }

                    var modalScope = $scope.$new(true);
                    modalScope.systemsSetForDecommission = systemsSetForDecommission;

                    var chooseModal = $modal({
                        scope: modalScope,
                        template: require('./summaryDecommissionSystemsModal.tpl.html'),
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        chooseModal.$promise.then(chooseModal.hide);
                    }

                    modalScope.okModal = function () {
                        completeReview(systemsToReviewForType);
                        modalScope.hideModal();
                    }

                });

            $scope.isProcessing = true;
        }

        $scope.goToSystemType = function (systemType) {
            $state.go('systemOwnerReview.authUser.decommissionSystems.bySystemType', {
                authLogin: $scope.authLogin,
                systemTypeSlug: systemType.SystemTypeSlug
            }, {
                reload: true
            })
        }

        $scope.goToGettingStarted = function () {
            $state.go('systemOwnerReview.authUser.gettingStarted', {}, {
                reload: true
            });
        }

        function completeReview (systemsToReview) {

            //  Set flag that is processing
            $scope.isProcessing = true;

            // Confirm step
            decommissionSystemsService
                .confirmReview($scope.authLogin, systemsToReview)
                .then(function (needToContinueReview) {
                    $scope.isProcessing = false;

                    // if there is no need to confirm any other system, go to main menu
                    if (needToContinueReview === "false") {
                        $state.go('systemOwnerReview.authUser.gettingStarted', {
                            authLogin: $scope.authLogin
                        }, {
                            reload: true
                        });

                    }
                    // go to the next system Type
                    else if (!_.isUndefined(systemNotInType)) {
                        $scope.goToSystemType(systemNotInType);
                        return;
                    }
                });
        }
    }]);
